import { Box, Divider, Grid } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { AppConfig } from '../../../config/app';
import { AuthApi } from '../../../providers/api-provider';
import ButtonWithStore from '../libs/ButtonWithStore';
import Dialog from '../libs/Dialog';
import { consumePreferredRoute, getAdminRoles, handleInputState, handleResponseErrors, inIframe, postMessageToParent, setCookie, showError, showSuccess } from '../libs/helpers';
import styles from './styles/login';

/* Login Component */
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }
  state = {
    errors: {
      email: false,
      password: false,
      enabled: false,
    },
    role: '',
    email: '',
    password: '',
    recaptcha: '',
    loading: false,
    showRoleModal: false,
  }
  recaptchaRef = React.createRef()
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  /* API Call */
  performLogin = (store) => {
    if (this.checkErrors()) {
      this.setState({ loading: true });
      AuthApi.login(this.state.email, this.state.password, this.state.recaptcha)
        .then((res) => {
          //Set cookie for wordpress website
          setCookie('x_t', res.data.token);
          //
          showSuccess('Welcome Home');
          this.setState({ loading: false });
          store.auth.login(res.data);
          const role = store.state.auth.user.role;
          //If it was called from edseed.me send a message
          if (inIframe()) {
            postMessageToParent('login', {
              loggedIn: true,
              userInfo: res.data
            });
            return;
          }
          const redirectTo = role !== 'guest' ? consumePreferredRoute(role) : null;
          if (redirectTo) {
            if (redirectTo.indexOf('http') === 0)
              window.location.href = redirectTo;
            else
              this.props.history.push(redirectTo);
            return;
          }
          if (['/login', '/logout'].indexOf(this.props.location.pathname) !== -1)
            this.props.history.push(getAdminRoles().indexOf(role) !== -1 ? '/admin' : '/');
          else
            this.props.history.push(this.props.location.pathname);
        }).catch((error) => {
          let newState = this.state;
          //Show SnackBar
          showError(error);
          newState.errors = handleResponseErrors(error, this.state.errors);
          newState.loading = false;
          this.setState(newState);
          //Reset Recaptcha
          if (this.recaptchaRef && this.recaptchaRef.current)
            this.recaptchaRef.current.props.grecaptcha.reset();
        });
    }
  }
  performRegisterAction = () => {
    if (!this.state.role) {
      showError('Choose a role please!');
      return;
    }
    if ((['/login', '/logout', '/social-login/'].indexOf(this.props.history.location.pathname) === -1))
      localStorage.setItem('pref-route', this.props.history.location.pathname);
    if (this.state.role === 'donor') {
      this.props.history.push('/donor/register');
    } else {
      this.props.history.push('/register');
    }
  }
  performSocialLoginAction = (url) => {
    return () => {
      if (['/login', '/logout', '/social-login/'].indexOf(this.props.history.location.pathname) === -1)
        localStorage.setItem('pref-route', this.props.history.location.pathname);
      window.location.href = AppConfig.api + url;
    }

  }
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */
  handleRegisterClicked = () => {
    this.setState({ showRoleModal: true });
  }
  hideRoleModal = () => {
    this.setState({ showRoleModal: false });
  }
  setRole = (role) => {
    return () => this.setState({ role: role });
  }

  /* Validate Form */
  checkErrors = () => {
    let errors = {
      email: this.state.email === '',
      password: this.state.password === '',
      enabled: this.state.password === '' || this.state.email === '',
    };
    this.setState({
      errors: errors,
    });
    return !errors.enabled;
  }
  /* Hanle State Management of form */
  onChange = handleInputState
  onReCapatchChange = (value) => {
    this.setState({ recaptcha: value });
  }
  /* Render Page */
  render() {
    const { classes } = this.props;
    const { errors, loading, showRoleModal, role } = this.state;
    return (
      <div>
        <main className={classes.main}>
          <CssBaseline />
          <Paper className={classes.paper} style={{ backgroundColor: '#ffffffe6' }}>
            <Avatar className={classes.avatar}>
              <img alt='edSeed Logo ' src={AppConfig.base + '/logo.png?v1'} style={{ width: '95%' }} />
            </Avatar>
            <Typography component="h1" variant="h5" style={{ width: '100%' }}>
              Login
            </Typography>
            <form className={classes.form}>
              <FormControl margin="normal" fullWidth error={errors.email && errors.enabled}>
                <InputLabel htmlFor="email">Email Address</InputLabel>
                <Input id="email" name="email" autoComplete="email" type='email' autoFocus onChange={this.onChange} />
                {errors.email && errors.enabled ? <FormHelperText >{errors.email}</FormHelperText> : ''}
              </FormControl>
              <FormControl margin="normal" fullWidth error={errors.password && errors.enabled} >
                <InputLabel htmlFor="password">Password</InputLabel>
                <Input name="password" type="password" id="password" autoComplete="current-password" onChange={this.onChange} />
                {errors.password && errors.enabled ? <FormHelperText >{errors.password}</FormHelperText> : ''}
              </FormControl>
              {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            /> */}
              {/* <ReCAPTCHA
                sitekey={ReCAPTCHAConfig.site_key}
                onChange={this.onReCapatchChange}
                ref={this.recaptchaRef}
              /> */}
              <ButtonWithStore title='Login' fullwidth={true} disabled={loading} action={this.performLogin} />
            </form>
            <Box marginBottom={2} marginTop={2} width="100%" >
              <Typography align="center" className={classes.orSocialMediaText} color="textSecondary">
                <span>or Login/Sign Up with</span>
              </Typography>
            </Box>
            {/* Google Login */}
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Button type="button" class="google-button" onClick={this.performSocialLoginAction('/auth/google/redirect')}>
                  <span class="google-button__icon">
                    <svg viewBox="0 0 366 372" xmlns="http://www.w3.org/2000/svg"><path d="M125.9 10.2c40.2-13.9 85.3-13.6 125.3 1.1 22.2 8.2 42.5 21 59.9 37.1-5.8 6.3-12.1 12.2-18.1 18.3l-34.2 34.2c-11.3-10.8-25.1-19-40.1-23.6-17.6-5.3-36.6-6.1-54.6-2.2-21 4.5-40.5 15.5-55.6 30.9-12.2 12.3-21.4 27.5-27 43.9-20.3-15.8-40.6-31.5-61-47.3 21.5-43 60.1-76.9 105.4-92.4z" id="Shape" fill="#EA4335" /><path d="M20.6 102.4c20.3 15.8 40.6 31.5 61 47.3-8 23.3-8 49.2 0 72.4-20.3 15.8-40.6 31.6-60.9 47.3C1.9 232.7-3.8 189.6 4.4 149.2c3.3-16.2 8.7-32 16.2-46.8z" id="Shape" fill="#FBBC05" /><path d="M361.7 151.1c5.8 32.7 4.5 66.8-4.7 98.8-8.5 29.3-24.6 56.5-47.1 77.2l-59.1-45.9c19.5-13.1 33.3-34.3 37.2-57.5H186.6c.1-24.2.1-48.4.1-72.6h175z" id="Shape" fill="#4285F4" /><path d="M81.4 222.2c7.8 22.9 22.8 43.2 42.6 57.1 12.4 8.7 26.6 14.9 41.4 17.9 14.6 3 29.7 2.6 44.4.1 14.6-2.6 28.7-7.9 41-16.2l59.1 45.9c-21.3 19.7-48 33.1-76.2 39.6-31.2 7.1-64.2 7.3-95.2-1-24.6-6.5-47.7-18.2-67.6-34.1-20.9-16.6-38.3-38-50.4-62 20.3-15.7 40.6-31.5 60.9-47.3z" fill="#34A853" /></svg>
                  </span>
                  <span class="google-button__text" style={{ paddingLeft: '10px' }}>Google</span>
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button type="button" class="google-button" onClick={this.performSocialLoginAction('/auth/facebook/redirect')}>
                  <span class="google-button__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="20" height="20" viewBox="0 0 619.032 620.188" class="svg-fblogo"><path d="M584.327.493H34.686C15.852.493.493 15.878.493 34.747v550.678c0 18.862 15.359 34.255 34.193 34.255h305.721V372.003h-92.702v-92.875h92.702v-61.923c0-79.949 38.894-123.132 110.083-123.132 34.101 0 66.395-1.841 75.325-.707v92.883h-61.803c-38.713 0-30.899 3.908-30.899 30.956v61.923h92.702l-30.901 92.875h-61.801V619.68h151.214c18.826 0 34.194-15.393 34.194-34.255V34.747c0-18.869-15.368-34.254-34.194-34.254z" fill="#3b5998" stroke="#3b5998" fillRule="evenodd" /></svg>
                  </span>
                  <span class="google-button__text" style={{ paddingLeft: '10px' }}>Facebook</span>
                </Button>
              </Grid>
            </Grid>
            {/*    <Button type="button" class="google-button" onClick={this.performSocialLoginAction('/auth/linkedin/redirect')}>
              <span class="google-button__icon">
                <img style={{ width: '24px' }} src={require('../../../images/ln.png')} />
              </span>
              <span class="google-button__text" style={{ paddingLeft: '18px' }}>Login/Sign Up using LinkedIn</span>
            </Button> */}
            <Typography component="h5" className='toppadding-xs' color='textSecondary'>
              {'Don\'t have an account? Sign Up '}
              <Link variant='text' color='primary' style={{ minWidth: 0, textDecoration: 'none' }} className='nopadding' onClick={this.handleRegisterClicked}>
                <Typography display="inline" color='textPrimary' component="h5" className='toppadding-xs'>
                  Here
                </Typography>
              </Link>.
            </Typography>
            <Link to='reset-password' style={{ textDecoration: 'none' }} >
              <Typography color='textPrimary' component="h5" className='toppadding-xs'>Forgot your password?
            </Typography></Link>

          </Paper>
        </main>
        <Dialog
          title="I'm a ..."
          show={showRoleModal}
          triggerHide={this.hideRoleModal}
          onClick={this.performRegisterAction}
        >
          <Button variant={role === 'student' ? 'contained' : 'outlined'} onClick={this.setRole('student')} className={classes.role} color='primary'>Student</Button>
          <Button variant={role === 'donor' ? 'contained' : 'outlined'} onClick={this.setRole('donor')} className={classes.role} color='primary'>Donor/Mentor</Button>
        </Dialog>
      </div>

    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(Login));
